import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import { 
 Shield, // For Basic Protection
 Package, // For Standard Quality
 Box, // For Easy Access
 Scale // For Size Options
} from 'lucide-react';

const ProductCategory2 = () => {
 const features = [
   {
     icon: Shield,
     title: "Basic Protection", 
     description: "Standard protective features suitable for regular shipping and routine deliveries.",
     bgColor: "#4CAF50" // Green for protection
   },
   {
     icon: Package,
     title: "Quality Build",
     description: "Constructed with durable materials to withstand normal shipping and handling processes.",
     bgColor: "#FF9800" // Orange for quality
   },
   {
     icon: Box,
     title: "Easy Access",
     description: "Simple sealing mechanism providing basic security while allowing convenient access when needed.",
     bgColor: "#2196F3" // Blue for convenience  
   },
   {
     icon: Scale,
     title: "Multiple Sizes",
     description: "Available in various standard sizes to meet different packaging requirements cost-effectively.",
     bgColor: "#9C27B0" // Purple for variety
   }
 ];

 return (
   <div className="container py-5">
     <div className="text-center mb-5">
       <h2 className="main-heading display-5 fw-bold mb-3">Discover Features</h2>
       <p className="product-each-desc text-muted mx-auto" style={{ maxWidth: '700px' }}>
       Cost-effective courier bags featuring durable polyethylene construction and standard security seals, ideal for regular shipping where advanced tracking isn't required.
       </p>
     </div>

      {/* Features Grid */}
      <div className="row g-4">
       {features.map((feature, index) => {
         const IconComponent = feature.icon;
         return (
           <div key={index} className="col-12 col-sm-6 col-lg-3">
             <div className="card h-100 border-0 shadow-sm feature-card">
               <div className="text-center mt-4">
                 <div 
                   className="icon-container d-inline-flex align-items-center justify-content-center rounded-3 mb-4"
                   style={{ background: feature.bgColor }}
                 >
                   <IconComponent size={40} className="icon-img" />
                 </div>
               </div>
               
               <div className="card-body text-center">
                 <h3 className="card-title h5 mb-3">{feature.title}</h3>
                 <p className="card-text text-muted mb-4">{feature.description}</p>
               </div>
             </div>
           </div>
         );
       })}
     </div>

      {/* Custom CSS */}
      <style>
        {`
          .feature-card {
            transition: all 0.3s ease;
            position: relative;
            overflow: hidden;
          }

          .feature-card::after {
            content: '';
            position: absolute;
            bottom: 0;
            left: 0;
            width: 0;
            height: 3px;
            background-color: #dc3545;
            transition: width 0.3s ease;
          }

          .feature-card:hover {
            transform: translateY(-10px);
          }

          .feature-card:hover::after {
            width: 100%;
          }

          .icon-container {
            width: 80px;
            height: 80px;
            transition: all 0.3s ease;
          }

          .icon-img {
            width: 60px;
            height: 60px;
            // filter: brightness(0) invert(1);
          }

          .read-more-link {
            color: #212529;
            position: relative;
            display: inline-block;
          }

          .read-more-link:hover {
            color: #0d6efd;
          }

          .feature-card:hover .icon-container {
            transform: scale(1.1);
          }
        `}
      </style>
    </div>
  );
};

export default ProductCategory2;